module.exports = __webpack_public_path__ + "static/media/job_fridge.0544d89b.svg";